import { render, staticRenderFns } from "./UserTasks.vue?vue&type=template&id=403578c8"
import script from "./UserTasks.vue?vue&type=script&lang=js"
export * from "./UserTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports